import React from 'react';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import user from '../../Mobx/User';
import Button from '@mui/material/Button';

const Logout = observer(() => {
    const navigate = useNavigate();

    const handleLogout = () => {
        user.logout();
        navigate('/login');
    };

    return (
        <Button
            variant="outlined"
            onClick={handleLogout}
            sx={{
                fontSize: '13px',
                ml: 2,
                px: 2,
                py: 0.5,
                borderRadius: '20px',
                textTransform: 'none',
                color: '#ffffff',
                borderColor: '#ffffff',
                transition: '0.3s',
                '&:hover': {
                    backgroundColor: '#d32f2f',
                    color: '#ffffff',
                    borderColor: '#d32f2f',
                },
            }}
        >
            יציאה
        </Button>
    );
});

export default Logout;
